import React from 'react';
import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import FeaturedProperties from '../components/FeaturedProperties/FeaturedProperties';
import BrowseByCity from '../components/BrowseByCity/BrowseByCity';
import BrowseByPropertyType from '../components/BrowseByPropertyType/BrowseByPropertyType';
import RealEstateTools from '../components/RealEstateTools/RealEstateTools';
import TrustedPlatform from '../components/TrustedPlatform/TrustedPlatform';
import TrustSignals from '../components/TrustSignals/TrustSignals';
import BlogPreview from '../components/BlogPreview/BlogPreview';
import CallToAction from '../components/CallToAction/CallToAction';
import Footer from '../components/Footer/Footer';

function LandingPage() {
  return (
    <div className="landing-page">
      <Header />
      <Hero />
      <FeaturedProperties />
      <TrustSignals />
      <BrowseByCity />
      <BrowseByPropertyType />
      <RealEstateTools />
      <TrustedPlatform />
      <BlogPreview />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default LandingPage;
